import { singleton } from "tsyringe";
import BaseProjectIdApi from "./BaseProjectIdApi";

@singleton()
export default class PosterApi extends BaseProjectIdApi {
	protected override getBaseUrl(params: Record<string, string>): string {
		return `${super.getBaseUrl(params)}/poster`;
	}

	public async getPosterImage(projectId: string) {
		return this.getBlobRequest(`${this.getBaseUrl({ projectId })}/download`);
	}

	public async changeGeneratedPosterImage(projectId: string) {
		return this.postRequest<{ discarded: boolean } | { next: true }>(`${this.getBaseUrl({ projectId })}/change`);
	}

	public async canDiscardGeneratedPosterImage(projectId: string) {
		return this.getRequest<{ canDiscard: boolean }>(`${this.getBaseUrl({ projectId })}/can-discard`);
	}

	public async updatePoster(projectId: string, file: File) {
		const formData = new FormData();
		formData.append("file", file);
		return this.putRequestFormdata<void>(`${this.getBaseUrl({ projectId })}/deposit`, formData);
	}
}
